/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { PureComponent, Fragment } from 'react';
import {
  arrayOf,
  shape,
  string,
  number,
  func,
  bool,
} from 'prop-types';
import classNames from 'classnames';
import {
  Button,
  Icon,
  Collapsible,
} from 'components/common';
import { Typography, mediaQueries, sizes } from '@hyphengroup/cag-components';
import styled from 'styled-components';

import './ResultsPageBanner.scss';

export const staticTextKeys = [
  'resultsCountLabel',
  'sortByLabel',
  'RESULT_PAGE_BANNER_EDIT_LABEL',
];

const ResultsPageHeader = styled.div`
  ${({ existHeading }) => `
  max-width: ${sizes(150)};
  margin: 0 auto;
  text-align: left;

  ${existHeading && `
    word-break: break-word;
  `}

  `}
`;


const ResultsPageSubHeadingTitleWrapper = styled.div`
  max-width: ${sizes(150)};
  margin: 0 auto;
  font-size: 16px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaQueries.medium} {
    justify-content: left;
  }
`;

const ResultsPageSubHeadingTitle = styled.h1`
  display: none;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400; 
  ${mediaQueries.medium} {
    display: inline-block;
  }
`;

const ResultsPageSubHeadingTitleSeeMore = styled.div`
  display: flex;
  align-items: center;
  ${mediaQueries.medium} {
    margin-left: 32px;
  }
`;

export default class ResultsPageBanner extends PureComponent {
  static propTypes = {
    heading: string,
    subHeadingTitle: string,
    subHeading: string,
    defaultList: string,
    listFilter: shape({}),
    list: string,
    sortByList: arrayOf(
      shape({
        name: string.isRequired,
        value: string.isRequired,
      })
    ),
    sortByValue: string,
    onListChange: func,
    onSortByChange: func,
    staticText: shape({}).isRequired,
    resultsCount: number,
    onFilterButtonClick: func,
    verticalName: string,
    isShowEditButton: bool,
    onEditButtonClick: func,
  };

  static defaultProps = {
    heading: null,
    subHeadingTitle: null,
    subHeading: null,
    defaultList: null,
    listFilter: {},
    list: string,
    sortByList: [],
    onListChange: null,
    onSortByChange: null,
    sortByValue: null,
    onFilterButtonClick: undefined,
    resultsCount: 0,
    verticalName: null,
    isShowEditButton: false,
    onEditButtonClick: undefined,
  };

  constructor(props) {
    super(props);
    const isExpanded = false;

    this.state = {
      isExpanded,
    };
    this.onListChange = this.onListChange.bind(this);
    this.onSortByChange = this.onSortByChange.bind(this);
  }

  onListChange(newProduct) {
    const { onListChange, listFilter: { queryParam, route } } = this.props;

    if (onListChange) {
      onListChange({
        queryParam,
        route,
        ...newProduct,
      });
    }
  }

  onSortByChange(newSortByProp) {
    const { onSortByChange } = this.props;

    if (onSortByChange) {
      onSortByChange(newSortByProp);
    }
  }

  parseResultsCountLabel = (label, count) => (label ? label.replace('${count}', count) : '');

  async toggleSubHeading() {
    const { isExpanded } = this.state;

    this.setState({
      isExpanded: !isExpanded,
    });
  }


  render() {
    const {
      heading,
      subHeadingTitle,
      subHeading,
      staticText,
      defaultList,
      listFilter,
      list,
      sortByList,
      onFilterButtonClick,
      verticalName,
      sortByValue,
      resultsCount,
      isShowEditButton,
      onEditButtonClick,
    } = this.props;

    const { isExpanded } = this.state;

    const listOptions = (listFilter.options || []).map(({ value: label, name: value }) => ({
      label,
      value,
    }));

    const hasListOptions = listOptions && listOptions.length > 0;

    const selectListValue = list && typeof list === 'string' ? list : defaultList;

    return (
      <div className="search-result-banner">
        {heading
          && (
            <ResultsPageHeader existHeading={!!heading}>
              <Typography as="h1" weight="light" sizeFont="px24" variant="secondary" lineHeightStyle="dp32" spacing="none">
                {heading}
              </Typography>
            </ResultsPageHeader>
          )
        }
        {subHeadingTitle
            && (
                <>
                <ResultsPageSubHeadingTitleWrapper>
                  <ResultsPageSubHeadingTitle>
                    {subHeadingTitle}
                  </ResultsPageSubHeadingTitle>
                  <ResultsPageSubHeadingTitleSeeMore onClick={() => {
                    this.toggleSubHeading();
                  }}>
                    <div style={{whiteSpace: "nowrap"}}>
                      {staticText.resultsPageHeaderSeeMore}
                    </div>
                    <div
                      className="right-icon"
                      style={{margin: "10px"}}
                      >
                      <Icon name={isExpanded ? 'chevron_up' : 'chevron_down'} />
                    </div>
                  </ResultsPageSubHeadingTitleSeeMore>
                </ResultsPageSubHeadingTitleWrapper>
                <Collapsible isCollapsed={!isExpanded}>
                  <div>{subHeading}</div>
                </Collapsible>
                </>
            )
        }
        <div className="search-result-wrapper">
          <div className="search-result-count-edit-button-wrapper">
            {isShowEditButton && (
              <span className="edit-button-mobile">
                <Button
                  primary
                  styleName="ghost"
                  leftIconName="edit"
                  small
                  onClick={onEditButtonClick}
                >
                  {staticText.RESULT_PAGE_BANNER_EDIT_LABEL}
                </Button>
              </span>
            )}
            <div className="search-result-count-wrapper" data-selector="total-search-result-count" data-selector-value={resultsCount}>
              <span className={classNames({
                'search-result-count': true,
                'has-categories': hasListOptions,
              })}
              >
                <Typography as="h2" variant="secondary" weight="light" sizeFont="px14" lineHeightStyle="dp16" spacing="none">
                  {this.parseResultsCountLabel(staticText.resultsCountLabel, resultsCount)}
                </Typography>
              </span>
              {hasListOptions ? (
                <Fragment>
                  <span className="search-result-desktop-button">
                    <Button
                      as="select"
                      large
                      inline
                      value={selectListValue}
                      onChange={this.onListChange}
                      options={listOptions}
                      dataSelectorId="product-list-button-desktop"
                      dataSelectorValue={selectListValue}
                      fontSize="px14"
                      fontWeight="light"
                      fontStyle="secondary"
                    />
                  </span>
                  <div className="search-result-mobile-button">
                    <Button
                      as="select"
                      tertiary
                      small
                      fluid
                      value={selectListValue}
                      onChange={this.onListChange}
                      options={listOptions}
                      dataSelectorId="product-list-button-mobile"
                      dataSelectorValue={selectListValue}
                    />
                  </div>
                  {isShowEditButton && (
                    <span className="edit-button-desktop">
                      <Button
                        primary
                        styleName="ghost"
                        leftIconName="edit"
                        small
                        onClick={onEditButtonClick}
                        dataSelectorId="edit"
                      >
                        {staticText.RESULT_PAGE_BANNER_EDIT_LABEL}
                      </Button>
                    </span>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <span className="vertical-name-mobile">
                    <Typography variant="secondary" sizeFont="px14" weight="light">
                      {verticalName}
                    </Typography>
                  </span>
                  <span className="vertical-name-desktop">
                    <Typography variant="secondary" sizeFont="px14" weight="light">
                      {verticalName}
                    </Typography>
                    {isShowEditButton && (
                      <span className="edit-button-desktop">
                        <Button
                          primary
                          styleName="ghost"
                          leftIconName="edit"
                          small
                          onClick={onEditButtonClick}
                          dataSelectorId="edit"
                        >
                          {staticText.RESULT_PAGE_BANNER_EDIT_LABEL}
                        </Button>
                      </span>
                    )}
                  </span>
                </Fragment>
              )}
            </div>
          </div>
          {sortByList.length > 1 && (
            <div className="sort-by-desktop">
              <span className="sort-by-text">
                <strong>{staticText.sortByLabel}</strong>
              </span>
              <div className="sort-by-button">
                <Button
                  fluid
                  small
                  primary
                  styleName="ghost"
                  as="select"
                  value={sortByValue}
                  onChange={this.onSortByChange}
                  options={sortByList
                    .map(({ name: value, value: label }) => ({ label, value }))}
                  dataSelectorId="sort-by-desktop"
                />
              </div>
            </div>
          )}
          <div className="sort-by-mobile" onClick={onFilterButtonClick}>
            <Icon medium name="filter" />
          </div>
        </div>
      </div>
    );
  }
}
